import { useContext } from "react";
import { UserContext } from "../../auth/UserContext";
import { useLazyQuery } from "@apollo/client";
import { client, detailsQuery } from "./person";
import { FETCH_POLICY_CONFIG } from "../../constants/constants";
import { useI18n } from "../../i18n/I18n";

export const useGetPersonDetailsLazily = () => {
    const { activeOrganizationAccount } = useContext(UserContext);
    const fetchError = useI18n('person.fetch.error');
    const [getPersonDetailInfo, { loading: personDetailLoading }] = useLazyQuery(detailsQuery, {
        client,
        context: { headers: { ownerId: activeOrganizationAccount } },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });

    const getPersonDetail = async (id: string) => {
        const response =  await getPersonDetailInfo({
            variables: {
                id
            }
        })

        if(response.error) {
            throw new Error(fetchError);
        }

        return response.data?.person;
    };
    
    return { getPersonDetail, personDetailLoading };
}